// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 1%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===================================
   Header ergonomique responsive
=================================== */

.header {
    min-height: 100px;
    padding: 12px 0;
    background-color: #00bcd4;
    z-index: 999;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  .navbar-collapse.show {
    background-color: #00bcd4;
    padding: 10px;
    border-radius: 0 0 8px 8px;
  }
  
  .navbar-brand img {
    height: 75px;
    padding: 5px;
    border-radius: 8px;
    transition: transform 0.3s ease;
  }
  
  .navbar-brand img:hover {
    transform: scale(1.1);
  }
  
  .navbar-brand span {
    font-size: 1.5rem;
    font-weight: bold;
    color: #fff;
  }
  
  .navbar-nav .nav-link {
    font-size: 14px;
    padding: 15px 20px;
    color: #fff !important;
    transition: color 0.3s ease;
  }
  
  .navbar-nav .nav-link:hover,
  .navbar-nav .nav-item.active .nav-link {
    color: #e0f7fa !important;
  }
  
  .dropdown-menu {
    background-color: #00bcd4 !important;
    border-radius: 4px;
    padding: 0;
    border-top: 3px solid #008ba3;
    display: none;
    opacity: 0;
    transition: all 0.3s ease;
    position: absolute;
    z-index: 1050;
  }
  
  .nav-item.dropdown:hover .dropdown-menu,
  .nav-item.dropdown:focus-within .dropdown-menu {
    display: block;
    opacity: 1;
  }
  
  .dropdown-item {
    color: #fff !important;
    padding: 10px 20px;
    transition: background-color 0.3s ease;
    background-color: transparent !important;
  }
  
  .dropdown-item:hover {
    background-color: rgba(255, 255, 255, 0.2) !important;
  }
  
  .language-switcher {
    position: relative;
    display: flex;
    align-items: center;
  }
  
  .language-button {
    border: none;
    background: #fff;
    padding: 6px;
    cursor: pointer;
    color: #00bcd4;
    font-size: 1.25rem;
    border-radius: 50%;
    transition: background-color 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .language-button:hover {
    background-color: #e0f7fa;
  }
  
  .language-dropdown {
    position: absolute;
    top: 110%;
    right: 0;
    background-color: #00bcd4;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    z-index: 1000;
  }
  
  .language-option {
    padding: 8px 12px;
    cursor: pointer;
    color: white;
    transition: background-color 0.2s ease;
    white-space: nowrap;
    background-color: transparent;
    border: none;
  }
  
  .language-option:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
  
  .form-check-input {
    cursor: pointer;
  }
  
  /* Responsive adjustments */
  @media (max-width: 991px) {
    .navbar-collapse {
      padding: 10px;
      border-radius: 8px;
      margin-top: 10px;
      background-color: #00bcd4 !important;
    }
  
    .navbar-nav .nav-link {
      padding: 10px;
    }
  
    .language-switcher {
      margin-left: 10px;
    }
  
    .form-check {
      margin-left: 10px;
      display: flex;
      align-items: center;
    }
  
    .navbar-toggler {
      border: none;
      background-color: transparent;
    }
  
    .navbar-toggler-icon {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    }
  } 
  `, "",{"version":3,"sources":["webpack://./src/composant/Header.css"],"names":[],"mappings":"AAAA;;qCAEqC;;AAErC;IACI,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,yCAAyC;EAC3C;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC;IACpC,kBAAkB;IAClB,UAAU;IACV,6BAA6B;IAC7B,aAAa;IACb,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;EACf;;EAEA;;IAEE,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,sCAAsC;IACtC,wCAAwC;EAC1C;;EAEA;IACE,qDAAqD;EACvD;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,sCAAsC;IACtC,mBAAmB;IACnB,6BAA6B;IAC7B,YAAY;EACd;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,eAAe;EACjB;;EAEA,2BAA2B;EAC3B;IACE;MACE,aAAa;MACb,kBAAkB;MAClB,gBAAgB;MAChB,oCAAoC;IACtC;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;MACjB,aAAa;MACb,mBAAmB;IACrB;;IAEA;MACE,YAAY;MACZ,6BAA6B;IAC/B;;IAEA;MACE,yDAAgQ;IAClQ;EACF","sourcesContent":["/* ===================================\n   Header ergonomique responsive\n=================================== */\n\n.header {\n    min-height: 100px;\n    padding: 12px 0;\n    background-color: #00bcd4;\n    z-index: 999;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  }\n  \n  .navbar-collapse.show {\n    background-color: #00bcd4;\n    padding: 10px;\n    border-radius: 0 0 8px 8px;\n  }\n  \n  .navbar-brand img {\n    height: 75px;\n    padding: 5px;\n    border-radius: 8px;\n    transition: transform 0.3s ease;\n  }\n  \n  .navbar-brand img:hover {\n    transform: scale(1.1);\n  }\n  \n  .navbar-brand span {\n    font-size: 1.5rem;\n    font-weight: bold;\n    color: #fff;\n  }\n  \n  .navbar-nav .nav-link {\n    font-size: 14px;\n    padding: 15px 20px;\n    color: #fff !important;\n    transition: color 0.3s ease;\n  }\n  \n  .navbar-nav .nav-link:hover,\n  .navbar-nav .nav-item.active .nav-link {\n    color: #e0f7fa !important;\n  }\n  \n  .dropdown-menu {\n    background-color: #00bcd4 !important;\n    border-radius: 4px;\n    padding: 0;\n    border-top: 3px solid #008ba3;\n    display: none;\n    opacity: 0;\n    transition: all 0.3s ease;\n    position: absolute;\n    z-index: 1050;\n  }\n  \n  .nav-item.dropdown:hover .dropdown-menu,\n  .nav-item.dropdown:focus-within .dropdown-menu {\n    display: block;\n    opacity: 1;\n  }\n  \n  .dropdown-item {\n    color: #fff !important;\n    padding: 10px 20px;\n    transition: background-color 0.3s ease;\n    background-color: transparent !important;\n  }\n  \n  .dropdown-item:hover {\n    background-color: rgba(255, 255, 255, 0.2) !important;\n  }\n  \n  .language-switcher {\n    position: relative;\n    display: flex;\n    align-items: center;\n  }\n  \n  .language-button {\n    border: none;\n    background: #fff;\n    padding: 6px;\n    cursor: pointer;\n    color: #00bcd4;\n    font-size: 1.25rem;\n    border-radius: 50%;\n    transition: background-color 0.3s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .language-button:hover {\n    background-color: #e0f7fa;\n  }\n  \n  .language-dropdown {\n    position: absolute;\n    top: 110%;\n    right: 0;\n    background-color: #00bcd4;\n    border-radius: 4px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n    display: flex;\n    flex-direction: column;\n    z-index: 1000;\n  }\n  \n  .language-option {\n    padding: 8px 12px;\n    cursor: pointer;\n    color: white;\n    transition: background-color 0.2s ease;\n    white-space: nowrap;\n    background-color: transparent;\n    border: none;\n  }\n  \n  .language-option:hover {\n    background-color: rgba(255, 255, 255, 0.2);\n  }\n  \n  .form-check-input {\n    cursor: pointer;\n  }\n  \n  /* Responsive adjustments */\n  @media (max-width: 991px) {\n    .navbar-collapse {\n      padding: 10px;\n      border-radius: 8px;\n      margin-top: 10px;\n      background-color: #00bcd4 !important;\n    }\n  \n    .navbar-nav .nav-link {\n      padding: 10px;\n    }\n  \n    .language-switcher {\n      margin-left: 10px;\n    }\n  \n    .form-check {\n      margin-left: 10px;\n      display: flex;\n      align-items: center;\n    }\n  \n    .navbar-toggler {\n      border: none;\n      background-color: transparent;\n    }\n  \n    .navbar-toggler-icon {\n      background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 1%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n    }\n  } \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
